export enum ErrorCodes {
    USER_CANNOT_UPDATE_EVALUATION_ERROR = "quality.evaluation.update.permission.check.failed",
    USER_CANNOT_UPDATE_PRIVATE_COMMENTS_ERROR = "quality.evaluation.cannot.update.private.comments",
    ASSIGNEE_MISSING_PERMISSIONS_FOR_ASSIGNMENT_ERROR = "quality.evaluation.assignee.permission.check.failed",
    USER_CANNOT_CHANGE_ASSIGNEE_ERROR = "quality.evaluation.cannot.change.assignee",
    SURVEY_IS_ALREADY_FINISHED = "quality.survey.unauthenticated.already.finished",
    AUTHZ_POLICY_DENIED = "authz.policy.denied",
}
